import { RuntimeExceptionHandler } from '@ats/exceptions';
import { EXCEPTION_MESSAGES } from '@constants/exception';
import { isDeviceError } from '@stores/atoms/device';
import type { EventAttributes, EventName } from 'amazon-chime-sdk-js';
import { useSetAtom } from 'jotai';

export function useChimeException() {
  const setDeviceError = useSetAtom(isDeviceError);

  const sendEvent = (name: EventName, attributes: EventAttributes) => {
    const { meetingHistory, ...otherAttributes } = attributes;
    const recentMeetingHistory = meetingHistory?.filter(({ timestampMs }) => {
      return Date.now() - timestampMs < 5 * 60 * 1000;
    });

    switch (name) {
      case 'audioInputFailed':
        new RuntimeExceptionHandler({
          error: {
            name,
            message: JSON.stringify({
              ...otherAttributes,
              recentMeetingHistory,
            }),
          },
          message: EXCEPTION_MESSAGES.AUDIO_INPUT_ERROR,
        });

        setDeviceError(true);
        break;

      case 'videoInputFailed':
        new RuntimeExceptionHandler({
          error: {
            name,
            message: JSON.stringify({
              ...otherAttributes,
              recentMeetingHistory,
            }),
          },
          message: EXCEPTION_MESSAGES.VIDEO_INPUT_ERROR,
        });

        setDeviceError(true);
        break;
      case 'meetingStartFailed':
        new RuntimeExceptionHandler({
          error: {
            name,
            message: JSON.stringify({
              ...otherAttributes,
              recentMeetingHistory,
            }),
          },
          message: EXCEPTION_MESSAGES.MEETING_START_ERROR,
        });

        setDeviceError(true);
        break;
      case 'meetingFailed':
        new RuntimeExceptionHandler({
          error: {
            name,
            message: JSON.stringify({
              ...otherAttributes,
              recentMeetingHistory,
            }),
          },
          message: EXCEPTION_MESSAGES.MEETING_ERROR,
        });

        setDeviceError(true);
        break;
      default:
        break;
    }

    console.warn(`Event: ${name} with attributes: `, {
      ...otherAttributes,
      recentMeetingHistory,
    });
  };

  return { sendEvent };
}
